import PropTypes from "prop-types"
import styled from "styled-components"

import { Box, Typography } from "components/common"

const DividerText = styled(Typography).attrs((props) => ({
  as: "h2",
  color: props.theme.helpdesk.box.text,
  fontSize: { _: props.theme.fontSizes[18], tablet: props.theme.fontSizes[24] },
  ...props.theme.helpdesk.titleDivider,
}))`
  ${({ theme }) => `
    background-color: white;
    font-weight: normal;
    margin: 0 auto;
    margin-top: -14px;
    text-align: center;
    width: 60%;
    ${theme.mediaQueries.tablet`
      width: 45%;
      margin-top: -18px;
    `}
  `}
`

const DividerContainer = styled(Box).attrs((props) => ({
  borderTop: "1px solid",
  my: 4,
  ...props.theme.helpdesk.divider,
}))``

const TitleWithDivider = ({ text }) => {
  return (
    <DividerContainer>
      <DividerText>{text}</DividerText>
    </DividerContainer>
  )
}

TitleWithDivider.propTypes = {
  text: PropTypes.string,
}

export default TitleWithDivider
